module.exports = __webpack_public_path__ + "img/BG.86644a72.png";